import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Button, Card, Container, Modal } from 'semantic-ui-react'

import classnames from "classnames";
import { translate } from "../../addons/Translate";

import Footer from "../ui/Footer";
import NavTop from "../ui/NavTop";
import Modules from "../modules";

class LandingPage extends Component {
	state = {
		job_details_open: -1
	}

	componentDidMount() {
		if(this.props.match.params.job !== undefined) {
			for(var i in window.jobs) {
				if(window.jobs[i].url === this.props.match.params.job) {
					this.setState({
						job_details_open: parseInt(i, 10)
					});

					break;
				}
			}
		}
	}

	applyJob(e) {
		this.props.history.push('/apply'+e.currentTarget.dataset.id);
	} 

	handleCloseModal(e) {
		this.props.history.push('/');
		this.setState({
			job_details_open: -1
		});
	}

	handleOpenModal(e) {
		const id = parseInt(e.target.dataset.id, 10);
		this.props.history.push('/job/'+window.jobs[id].url);
		this.setState({
			job_details_open: id
		});
	}

	getPlainDescription(text, rows) {
		//replace li with -
		text = text.replace(/<li>/g, "<li>&#9679; ");

		//remove html tags
		var tmp = document.createElement("DIV");
   		tmp.innerHTML = text;

		text = tmp.textContent || tmp.innerText || "";
		text = text.replace(/&#?[a-z0-9]+;/g, "");

		const maxLength = Math.round((500 / rows) - 500 * 0.01 * rows);
		
		if(text.length > maxLength) {
			text = text.substring(0, maxLength) + "...";
		}

		return text;
	}

	renderBrand() {
		let content = null;
		const { restaurant } = window;

		if(restaurant.settings.logo_top !== null) {
			content = <img src={restaurant.settings.logo_top} className="logo-top" alt="Restaurant logo" />
		} else {
			content = [<div className="restaurant">{restaurant.name}</div>];

			if(window.options.base_url !== 'gastro') {
				const address = [];
				if(restaurant.city !== '') {
					address.push(restaurant.city);
				}
				if(restaurant.country !== '') {
					address.push(restaurant.country);
				}

				if(address.length > 0) {
					content.push(<div className="address">{address.join(' - ')}</div>);
				}
			}
		}

		return content;
	}

	renderJobsList() {
		const rows = window.jobs.length > 3 ? 3 : window.jobs.length;

		return (
			<Card.Group className="jobs" itemsPerRow={rows}>
				{
					window.jobs.map((item, key) => {
						return (
							<Card key={key}>
								<Card.Content>
									<Card.Header>{item.title}</Card.Header>
									<Card.Description>
										{translate("xxltable.jobs.time")}: {item.time_type_name}<br />
										{ item.date_to_unlimited === 0 ? translate("xxltable.jobs.application_deadline")+": "+item.deadline : "" }<br />
										{ this.getPlainDescription(item.description, rows) }
									</Card.Description>
								</Card.Content>
								<Card.Content extra>
									<Modal
										trigger={<Button onClick={this.handleOpenModal.bind(this)} data-id={key}>{translate("xxltable.btn_job_details")}</Button>}
										open={this.state.job_details_open === parseInt(key, 10)}
										onClose={this.handleCloseModal.bind(this)}
										>
										<Modal.Header>
											{item.title}

											{
												window.restaurant.settings.logo !== null && 
												<div class="logo">
													<img src={window.restaurant.settings.logo} alt="Logo" />
												</div>
											}
										</Modal.Header>
										<Modal.Content>
											<Modal.Description>
												<strong>{translate("xxltable.jobs.department")}:</strong> {item.department.name}<br />
												<strong>{translate("xxltable.jobs.time")}:</strong> {item.time_type_name}<br />
												{ item.date_to_unlimited === 0 ? <div><strong>{translate("xxltable.jobs.application_deadline")}:</strong> {item.deadline}<br /></div> : "" }<br />

												<div dangerouslySetInnerHTML={{__html: item.description}}></div>
											</Modal.Description>
										</Modal.Content>
										<Modal.Actions>
											<Button className="back_btn" onClick={this.handleCloseModal.bind(this)} data-id={key}>{translate("xxltable.btn_job_details_back")}</Button>
											<Link to={"/apply/"+item.id} className="ui button green left">
												{translate("xxltable.btn_apply_job")}
											</Link>
										</Modal.Actions>
									</Modal>
								</Card.Content>
							</Card>
						);
					})
				}
			</Card.Group>
		);
	}

	render() {
		const { restaurant } = window;
		const withJobsList = window.jobs.length > 0;

		return (
			<div id="LandingPage" className={classnames(restaurant.settings.color_schema, {withJobs: withJobsList})} style={{backgroundImage: `url("${restaurant.settings.background}")`}}>
				<NavTop />

				<div id="LandingPageContent">
					<Container textAlign="center">
						<div className="join">{translate("xxltable.header")}</div>

						{ this.renderBrand() }

						{withJobsList && <h4 className="jobs-title">{translate("xxltable.jobs.title")}</h4>}
						{withJobsList && this.renderJobsList()}

						<div className="not_find_job">{translate("xxltable.jobs.not_find_job")}</div>
						<Link to="/apply" className="ui button secondary huge">{translate("xxltable.header_btn")}</Link>
					</Container>

					<div className="gastrocv-logo">
						<img src={restaurant.settings.gastrocv_footer_logo} alt="GastroCV" />
						<p>{translate("xxltable.landingPage.footer")}</p>

						<Footer />
					</div>
				</div>

				<Modules page="landingpage" />
			</div>
		);
	}
}

export default LandingPage;


// WEBPACK FOOTER //
// ./src/components/pages/LandingPage.js